// Master only — admin_audit_log görüntüleme.
// İskelet: F1.2'de Geliştirici filtre + pagination + CSV export ekleyecek.

import { useEffect, useState } from 'react';
import { supabase, type AuditLogRow } from '../lib/supabase';

export default function ActivityLog() {
  const [rows, setRows] = useState<AuditLogRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void supabase
      .from('admin_audit_log')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(200)
      .then(({ data }) => {
        setRows((data ?? []) as AuditLogRow[]);
        setLoading(false);
      });
  }, []);

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-6xl">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800">📜 Activity log</h1>
        <p className="text-slate-500 text-sm">Son 200 kayıt — kim ne yaptı.</p>
      </div>

      {loading ? (
        <p className="text-slate-400">Yükleniyor…</p>
      ) : rows.length === 0 ? (
        <p className="text-slate-400">Kayıt yok.</p>
      ) : (
        <div className="bg-white border border-slate-200 rounded-xl overflow-x-auto">
          <table className="w-full text-sm min-w-[720px]">
            <thead className="bg-slate-50 text-xs uppercase text-slate-600">
              <tr>
                <th className="px-4 py-3 text-left">Tarih</th>
                <th className="px-4 py-3 text-left">Kullanıcı</th>
                <th className="px-4 py-3 text-left">Eylem</th>
                <th className="px-4 py-3 text-left">Hedef</th>
                <th className="px-4 py-3 text-left">Detay</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {rows.map((r) => (
                <tr key={r.id} className="hover:bg-slate-50">
                  <td className="px-4 py-3 text-slate-600 text-xs whitespace-nowrap">
                    {new Date(r.created_at).toLocaleString('tr-TR')}
                  </td>
                  <td className="px-4 py-3 text-slate-700 font-mono text-xs">{r.actor_email}</td>
                  <td className="px-4 py-3"><code className="text-xs bg-slate-100 px-1.5 py-0.5 rounded">{r.action}</code></td>
                  <td className="px-4 py-3 text-slate-600">{r.target_label ?? r.target_type ?? '—'}</td>
                  <td className="px-4 py-3 text-slate-500 text-xs font-mono max-w-md truncate">
                    {JSON.stringify(r.metadata)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="mt-6 bg-amber-50 border border-amber-200 rounded p-4 text-sm text-amber-800">
        <p className="font-medium mb-1">F1.2'de eklenecek:</p>
        <ul className="list-disc list-inside text-xs space-y-0.5">
          <li>Filtre — actor_email, action type, tarih aralığı</li>
          <li>Cursor-based pagination (created_at &lt; last_seen)</li>
          <li>CSV export</li>
        </ul>
      </div>
    </div>
  );
}
